<div class="restricted-layout">
	<div rtCard class="access-denied-card">
		<div class="w-100 access-denied-content">
			<h1 rtHeading class="rt-header-title m-3 text-center">Your are not allowed to access TCO²</h1>
			<p class="message-info m-0">If you have requested access, please sign in using your Volvo Group email address:</p>
			<ul class="text-left m-0" style="list-style: disc !important">
				<li>
					For an external user:
					<span class="font-weight-bold">{{ externalMail }}</span>
				</li>
				<li>
					For an internal user:
					<span class="font-weight-bold">{{ volvoMail }}</span> or
					<span class="font-weight-bold">{{ renaultTruckMail }}</span>
				</li>
			</ul>

			<div>
				<button type="submit" class="button rt-button active my-4" id="order-search-form-button" (click)="login()">
					<p class="m-0 px-2">I have my Volvo Group access</p>
				</button>
			</div>

			<p class="message-info m-0">If you don’t have requested access, please contact the support via:</p>
			<ul class="text-left" style="list-style: disc !important">
				<li>
					For an external user:&nbsp;
					<a class="rt-red-link font-weight-bold" target="_blank" rel="noopener" style="font-weight: 500" [href]="CSM_URL">
						Customer Service Management
					</a>
				</li>
				<li>
					For an internal user:&nbsp;
					<a class="rt-red-link font-weight-bold" target="_blank" style="font-weight: 500" rel="noopener" [href]="BUSINESS_APPLICATION_URL">
						Business Applications Access - ESC
					</a>
				</li>
			</ul>
		</div>
	</div>
</div>
